import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-textarea-autosize';

import useFileComments from '../useFileComments';
import Spinner from '../../Spinner';
import FileCommentItem from './FileCommentItem';
import SendIcon from '../../../icons/SendIcon';
import Button from '../../Button';
import Label from '../../Label';

const propTypes = {
  parentAccountFileComment: PropTypes.shape({
    id: PropTypes.string,
  }),
  replyInputRef: PropTypes.object,
  onRepliesLoaded: PropTypes.func,
  target: PropTypes.shape({
    fileCommentId: PropTypes.string,
    parentFileCommentId: PropTypes.string,
  }),
};

const FileCommentItemReplies = ({
  parentAccountFileComment,
  replyInputRef,
  onRepliesLoaded,
  target,
}) => {
  const [reply, setReply] = useState('');
  const {
    loading,
    comments,
    onCommentCreate,
    onCommentUpdate,
    onCommentDelete,
    user,
    isOwner,
  } = useFileComments({
    limit: 999,
    parentId: parentAccountFileComment?.id,
    photoId: parentAccountFileComment.photo?.id,
    videoId: parentAccountFileComment.video?.id,
  });

  useEffect(() => {
    if (!loading) {
      onRepliesLoaded();
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="file-comment-item-replies">
        <div className="p-5 w-100 d-flex">
          <Spinner className="m-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="file-comment-item-replies">
      {comments.map(accountFileComment => (
        <FileCommentItem
          key={accountFileComment.id}
          accountFileComment={accountFileComment}
          onCommentUpdate={onCommentUpdate}
          onCommentDelete={onCommentDelete}
          user={user}
          isOwner={isOwner}
          target={target}
        />
      ))}

      <div className="pos-rel">
        <Label labelSrOnly label="Add new reply" id="new-reply" />
        <TextareaAutosize
          className="new-reply-input form-control"
          placeholder="Add new reply"
          name="new-reply"
          id="new-reply"
          value={reply}
          onChange={event => {
            setReply(event.target.value);
          }}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              onCommentCreate(reply);
              setReply('');
              event.stopPropagation();
              event.preventDefault();
            }
          }}
          ref={replyInputRef}
        />
        <Button
          className="new-comment-send-button"
          btnStyle="reset"
          disabled={reply.length === 0}
          onClick={() => {
            onCommentCreate(reply);
            setReply('');
          }}
        >
          <SendIcon color={reply ? '#0d84fe' : '#cdd6e4'} />
        </Button>
      </div>
    </div>
  );
};

FileCommentItemReplies.propTypes = propTypes;

export default FileCommentItemReplies;
